import {Component, Input, OnChanges, OnInit, SimpleChanges} from '@angular/core';
import {Forecast} from "../interfaces/result-data.interface";
import {ModeratAnfrage} from "../anfrage/moderat.anfrage";

/**
 * Component to show the forecast teaser/images
 */
@Component({
    selector: 'app-sanierung-forecast',
    templateUrl: './sanierung-forecast.component.html',
    standalone: false
})
export class SanierungForecastComponent implements OnInit, OnChanges {
  /**
   * the request object
   */
  @Input() anfrage: ModeratAnfrage;

  /**
   * loading indicator
   */
  @Input() loading: boolean;

  /**
   * forecast data
   */
  forecast: Forecast;

  /**
   * translation key prefix
   */
  textkeyPrefix = 'moderat.sanierung.wirtschaftlichkeit.';

  /**
   * @inheritDoc
   */
  ngOnInit() {
    this.updateData();
  }

  /**
   * @inheritDoc
   * @param changes
   */
  ngOnChanges(changes: SimpleChanges): void {
    if(changes.loading && changes.loading.currentValue === false) {
      this.updateData();
    }
  }

  /**
   * update the data that we want to show, to trigger change detection
   */
  updateData(): void {
    this.forecast = this.anfrage.measureResult.saving.prognose_20_jahre;
  }
}
